import { PulseBaseProvider } from '../../base-classes';
import { getDistance } from '../../utilities/unitConversion';

// Cache key for lightning
const _lightningCacheKey = 'lightningProvCacheKey';
const _lightningUrl = '/data/lightning/v1/spark';

//Default is 40 seconds
const defaultCacheDuration = 40 * 1000;

export class LightningProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_lightningCacheKey] = this.lightningSyncer.bind(this);
    }

    async lightningSyncer(params) {
        const { id, syncParams, resolve, reject } = params;
        const { distanceUnit } = syncParams;
        let queryParams = {
            ...syncParams.stdParameters,
            verbose: syncParams.verbose,
            locationtype: 'latitudelongitude',
            location: `${syncParams.latitude},${syncParams.longitude}`,
            isGpsLocation: syncParams.isGpsLocation,
            pulseListAlert: syncParams.pulseListAlert,
            pulseListGlobal: syncParams.pulseListGlobal,
            safetyMessage: syncParams.safetyMessage,
            shortMessage: syncParams.shortMessage,
            units: 'English'
        };

        const unitConversionFunc = (result) => {
            if (result) {
                result.cpds = getDistance(result.cpds, distanceUnit, false, 2);
            }

            return result;
        };

        return await super.syncData(syncParams.key, id, queryParams, _lightningUrl, resolve, reject, null, syncParams.pulseApi, null, unitConversionFunc, true, syncParams.cacheDurationMilliseconds);
    }

    async getLightning(latitude, longitude, stdParameters, verbose, isGpsLocation, safetyMessage = true, shortMessage = true, refresh = false, distanceUnit, cacheDurationMilliseconds=defaultCacheDuration) {
        const syncParams = {
            latitude,
            longitude,
            verbose: !!verbose,
            isGpsLocation: !!isGpsLocation,
            pulseListAlert: false,
            pulseListGlobal: false,
            safetyMessage,
            shortMessage,
            refresh,
            cultureInfo: stdParameters?.cultureinfo,
            distanceUnit,
            cacheDurationMilliseconds
        };

        const id = JSON.stringify(syncParams);

        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_lightningCacheKey, id);
        }

        return await super.loadFromStorage(_lightningCacheKey, id, syncParams);

    }
}


